import { memo } from "react";
import {
    Container,
    Nav,
    Navbar,
    NavDropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import AVATAR from "../../assets/icons/avatar.svg";
import LOGO from "../../assets/logo.svg";
import { useAuth } from "../../auth/AuthContext";
import { MainNavigation } from "../../navigation";

const HeaderGlobal = memo(() => {
    const { logout, user } = useAuth();

    const avatarImageSrc = user?.person?.avatar_url || AVATAR;

    return (
        <Navbar expand="lg" className="py-3 mb-1 border-bottom bg-white">
            <Container>
                <Navbar.Brand
                    as={Link}
                    to="/"
                    className="d-flex align-items-center col-md-3 mb-2 mb-md-0 text-dark text-decoration-none">
                    <img
                        src={LOGO}
                        alt="AventaHub-MainLogo"
                        className="me-2"
                        style={{ height: '40px', width: 'auto' }}
                    />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto col-12 col-md-auto mb-2 justify-content-center mb-md-0">
                        {MainNavigation.map((item) => {
                            if (!item.sub) {
                                return (
                                    <Nav.Link
                                        key={item.text}
                                        href={item.slug}
                                        className={`px-2 ${item.text === "Home"
                                            ? "link-secondary"
                                            : "link-dark"
                                            }`}>
                                        {item.text}
                                    </Nav.Link>
                                );
                            } else {
                                return (
                                    <NavDropdown
                                        key={item.text}
                                        title={item.text}
                                        className="px-2 link-dark">
                                        {item.sub.map((subItem) => (
                                            <NavDropdown.Item
                                                key={subItem.text}
                                                as={Link}
                                                to={subItem.slug}>
                                                {subItem.text}
                                            </NavDropdown.Item>
                                        ))}
                                    </NavDropdown>
                                );
                            }
                        })}
                    </Nav>
                </Navbar.Collapse>

                <NavDropdown
                    title={
                        <img 
                            src={avatarImageSrc} 
                            alt="User Avatar" 
                            /* PROMJENA: Povećano sa 32px na 64px */
                            style={{ width: '64px', height: '64px', borderRadius: '50%', objectFit: 'cover' }} 
                        />
                    }
                    className="btn-avatar">
                    <NavDropdown.Item as={Link} to={user?.person?.id ? `/resources/${user.person.id}` : '/resources'}>
                        Profile
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={logout}>
                        Logout
                    </NavDropdown.Item>
                </NavDropdown>

            </Container>
        </Navbar>
    );
});

export default HeaderGlobal;